import React from 'react';
import { useTranslation } from 'react-i18next';

interface FormattedCurrencyProps {
  value: number | string;
  className?: string;
}

const FormattedCurrency: React.FC<FormattedCurrencyProps> = ({ value, className }) => {
  const { i18n } = useTranslation();
  const [intPart, decPart] = value.toString().split('.');
  const intPartFormatted = Number(intPart).toLocaleString(i18n.language);
  return (
    <span className={className}>
      {intPartFormatted}
      <sup>{decPart || '00'}</sup>$
    </span>
  );
};

export default FormattedCurrency;
